import { GetterTree } from 'vuex';
import { DateTimeManagement } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<DateTimeManagement, RootState> = {
  ['getDateTimes']: (state) => state.dateTimes,
  ['getDateTimesIsLoading']: (state) => state.dateTimes?.isLoading,
  ['getDateTimesTotal']: (state) => state.dateTimes?.total,
  ['getDateTimesSearchParams']: (state) => state.dateTimes?.searchParams,

  ['getDateTimesOfCourse']: (state) => state.dateTimesOfCourse,
  ['getDateTimesOfCourseIsLoading']: (state) =>
    state.dateTimesOfCourse?.isLoading,
  ['getDateTimesOfCourseTotal']: (state) => state.dateTimesOfCourse?.total,
  ['getDateTimesOfCourseSearchParams']: (state) =>
    state.dateTimesOfCourse?.searchParams,
};
